<script lang="ts">
  import { RefreshCw } from '@lucide/svelte';
  import { fa } from '../i18n/fa';
  import { applyUpdate, quietUpdate } from '../pwa/update.svelte';
  import Button from './Button.svelte';

  /** Shown only while a new version waits because the user is busy; one tap applies it. */
  const waiting = quietUpdate();
</script>

{#if waiting.ready}
  <div
    role="status"
    class="sticky top-0 z-50 flex flex-wrap items-center justify-center gap-x-3 gap-y-1 bg-accent-solid px-4 py-1.5 text-sm text-on-accent"
  >
    <RefreshCw class="size-4 shrink-0" aria-hidden="true" />
    <span>{fa.app.updateReady}</span>
    <Button size="sm" variant="secondary" class="min-h-8 border-transparent" onclick={applyUpdate}>{fa.app.updateNow}</Button>
  </div>
{/if}
